"use client";

import { useState, useEffect } from "react";
import FilterButton from "./FilterButton";
import ClearButton from "./ClearButton";

export default function FilterBar({ type = "event", onFilterChange }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_REACT_APP_SERVER}/tags?type=${type}`,
          { credentials: "include" } // only if you’re checking session cookies
        );
        if (!res.ok) throw new Error("Failed to fetch tags");
        const data = await res.json();
        setTagOptions(data.map((tag) => tag.name));
      } catch (err) {
        console.error("Error fetching tags:", err);
      }
    };
    fetchTags();
  }, [type]);

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const clearFilters = () => {
    setSelectedTags([]);
    onFilterChange?.([]);
  };

  const handleApplyFilters = () => {
    onFilterChange?.(selectedTags);
    setShowDropdown(false);
  };

  return (
    <div className="w-full border-t-2 border-b-2 border-black py-2 px-4 flex justify-between items-center relative bg-white">
      <ClearButton onClick={clearFilters} />
      <FilterButton
        onClick={() => setShowDropdown(!showDropdown)}
        active={showDropdown}
      />
      {showDropdown && (
        <div
          className="absolute top-full mt-2 right-0 w-[50%] md:w-[20%] bg-white border border-gray-300 rounded shadow max-h-64 z-10 flex flex-col"
          onMouseLeave={() => setShowDropdown(false)}
        >
          {/* Scrollable tags container */}
          <div className="overflow-y-auto text-base max-h-[240px] px-4">
            {tagOptions.map((tag) => (
              <label
                key={tag}
                className="flex items-center py-2 hover:bg-gray-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selectedTags.includes(tag)}
                  onChange={() => toggleTag(tag)}
                  className="mr-2"
                />
                {tag}
              </label>
            ))}
          </div>

          {/* Fixed footer with Apply button */}
          <div className="border-t p-2 bg-white flex justify-end sticky bottom-0">
            <button
              onClick={handleApplyFilters}
              className="px-4 py-1 bg-accentyellow  rounded hover:bg-darkaccentyellow"
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
